import React from 'react';
import { findDOMNode } from 'react-dom';
import config from '../../config';
import { DragSource, DropTarget } from 'react-dnd';
import LocationRow from './LocationRow';
import CourseSlug from './CourseSlug'

const courseSource = {
  beginDrag(props) {
    return {
      course: props.course,
      index: props.index,
      target: props.target
    };
  }
};
const courseTarget = {
  hover(props, monitor, component) {
    const dragItem = monitor.getItem();
    const dragIndex = dragItem.index;
    const hoverIndex = props.index;
    const dropTarget = props.target;

    // Don't replace items with themselves
    if (dragItem.course.id == props.course.id) {
      return;
    }

    if(dropTarget == dragItem.target) {
      // Determine rectangle on screen
      const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();
      // console.log('hoverBoundingRect',hoverBoundingRect);

      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // console.log('clientOffset:', clientOffset);

      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // console.log('hoverClientY:', hoverClientY);

      // Get vertical middle
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 5;
      // console.log('hoverMiddleY',hoverMiddleY);


      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%

      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        props.moveClass(-1, -1, dropTarget, true);
        component.state = {
          ...component.state,
          isUp: false,
          isDown: true
        }
        return;
      }

      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        props.moveClass(-1, -1, dropTarget, true);
        component.state = {
          ...component.state,
          isUp: true,
          isDown: false
        }
        return;
      }

      // Time to actually perform the action
      component.state = {
        ...component.state,
        isOverHalf : true
      }
      //console.log('dragIndex:', dragIndex,'hoverIndex:',hoverIndex,'hoverClientY:', hoverClientY,'hoverMiddleY:',hoverMiddleY);

      props.moveClass(dragIndex, hoverIndex, dropTarget, true);
      component.state = {
        ...component.state,
        isOverHalf : false
      }
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      // monitor.getItem().index = hoverIndex;
      return;
    } else {
      props.moveClass(dragIndex, hoverIndex, dropTarget, false);
      return;
    }

  }
};
function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }
}
function drop(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  }
}

class ClassDndRow extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOverHalf: false,
      isUp: false,
      isDown: false
    }
    this.isLinked = this.isLinked.bind(this);
  }
  isLinked(id){
    if(this.props.linkedCourses && this.props.linkedCourses.length > 0) {

      let c = this.props.linkedCourses.filter(courseId => {
        return courseId == id
      });
      if(c[0]) {
        return true;
      } else {return false}
    }
  }
  render() {
    // This const binding means we need to getCourseLocations by course.id, not by course
    const { course, connectDragSource, connectDropTarget, isDragging, getCourseLocations, target, removeItem } = this.props;
    return connectDragSource(connectDropTarget(
      <div className="trans">
        {this.state.isUp && this.state.isOverHalf ?
          <div style={{
            height: '60px',
            opacity: 0.4,
            backgroundColor: '#3a9ed0',
            position: 'relative'
          }} className="tr"></div>
          : null}
        <div style={{
          opacity: isDragging ? 0.5 : 1,
          cursor: 'move'
        }} className={`tr ${this.state.isOverHalf ? 'is-over-drop' : ''} ${this.state.isUp ? 'isUp' : ''} ${this.state.isDown ? 'isDown' : ''}`}>
          <div className="td find-class-name w-200"><CourseSlug course={course} /></div>
          <div className="td class-desc w-400">{course.longname}</div>
          <div className="td class-desc w-200">{course.instructor}</div>
          <div className="td class-desc w-200">
            <LocationRow
              locations={getCourseLocations(course.id)}
            />
          </div>
          <div className="td class-desc w-100">{course.weight}</div>
          <div className="td w-100 text-center font-size-18"><i className="fa fa-trash" onClick={()=>{removeItem(target, course)}}></i></div>
        </div>
        {this.state.isDown && this.state.isOverHalf ?
          <div style={{
            height: '60px',
            opacity: 0.4,
            backgroundColor: '#3a9ed0',
            position: 'relative'
          }}></div>
          : null}
      </div>
    ));
  }
}

ClassDndRow = DropTarget(config.dndTypes.CLASS, courseTarget, drop)(ClassDndRow);
ClassDndRow = DragSource(config.dndTypes.CLASS, courseSource, collect)(ClassDndRow);

export default ClassDndRow;




// WEBPACK FOOTER //
// ./src/components/rank/ClassDndRow.js